import { GfsOfferOverviewPage } from "@/services/backend/gfs/offer/components/offer-overview-page";

export default function GfsOfferOverviewRoute() {
  return <GfsOfferOverviewPage />;
}
